<script lang="ts">
	import { format } from 'svelte-i18n';
	import type { EnergyTariff } from 'src/types/EnergyTariff';

	export let tariff: EnergyTariff;
	export let pricePerKwhCents: string;
	export let basePriceMonthly: string;
	export let pricePerKwh: number | undefined;
	export let basePrice: number | undefined;
	export let variant: 'light' | 'dark' = 'light';
</script>

<div
	class="tariff-pricing"
	class:variant-light={variant === 'light'}
	class:variant-dark={variant === 'dark'}
>
	<div class="pricing-main">
		{#if pricePerKwh !== undefined}
			<div class="pricing-left">
				<span class="detail-label"
					>{tariff.cost?.unitPrice?.caption?.text ||
						$format('label_labor_price', {
							default: 'Arbeitspreis',
							locale: 'de',
						})}</span
				>
				<span class="detail-value price-bold"
					>{tariff.cost?.unitPrice?.content?.text || pricePerKwhCents + 'ct/kW h'}</span
				>
			</div>
		{/if}
		{#if basePrice !== undefined && basePrice > 0}
			<div class="pricing-right">
				<span class="detail-label"
					>{tariff.cost?.fixedCosts?.caption?.text ||
						$format('label_base_price', { default: 'Grundpreis', locale: 'de' })}</span
				>
				<span class="detail-value price-bold"
					>{tariff.cost?.fixedCostsMonthly?.content?.text || basePriceMonthly + ' €'} /Monat
				</span>
			</div>
		{/if}
	</div>
</div>

<style>
	.tariff-pricing {
		display: flex;
		flex-direction: column;
		gap: 8px;
		margin-top: 8px;
	}

	.pricing-main {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 16px;
		align-items: start;
	}

	.pricing-left,
	.pricing-right {
		display: flex;
		flex-direction: column;
		gap: 2px;
	}

	.detail-label {
		font-size: 11px;
		color: var(--color-text-secondary, #6b7280);
		font-weight: 400;
	}

	.tariff-pricing.variant-light .detail-label {
		color: rgba(255, 255, 255, 0.8);
	}

	.detail-value {
		font-size: 14px;
		color: var(--color-text-primary, #000000);
		font-weight: 400;
	}

	.detail-value.price-bold {
		font-weight: 700;
	}

	.tariff-pricing.variant-light .detail-value {
		color: #ffffff;
	}

	.tariff-pricing.variant-dark .detail-value {
		color: var(--color-text-primary, #000000);
	}

	@media (max-width: 768px) {
		.tariff-pricing {
			margin-top: 12px;
		}

		.pricing-main {
			grid-template-columns: 1fr;
			gap: 12px;
		}

		.pricing-left,
		.pricing-right {
			gap: 4px;
		}

		.detail-value.price-bold {
			font-size: 16px;
		}
	}
</style>
